export const blockAnimator = (): void => {
  let allAnimatedElements = Array.from(document.querySelectorAll('.js-animatedElement'))

  const checkFunction = () => {
    const scrollTop = window.scrollY
    const windowHeight = window.innerHeight

    allAnimatedElements.forEach((el, i) => {
      const elementOffset = (el.getBoundingClientRect()).top + window.pageYOffset
      // Animate if in view
      if (scrollTop >= elementOffset - windowHeight) {
        // Filter out already animated elements to reduce render load
        allAnimatedElements.splice(i, 1)
        el.classList.add('-inView')
      }
    })
  }

  // Run checker
  window.addEventListener('scroll', (event) => {
    checkFunction()
  })
  window.addEventListener('resize', (event) => {
    checkFunction()
  })

  document.addEventListener('DOMContentLoaded', (event) => {
    // Run once on start
    setTimeout(() => {
      checkFunction()
    }, 1000)
  })
}
